import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserApiController } from '../../../modules/src/lib/advanced-auth/api-controllers/user.api-controller';
import { GuardsCheckEnd, GuardsCheckStart, NavigationCancel, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  public isApplicationLoading = true;

  constructor(private translate: TranslateService, private readonly userApiController: UserApiController, private router: Router) {
    this.translate.setDefaultLang('fr');
    this.translate.use('fr');

    // Need this to force translate service to load all languages we support
    // Todo re enable english when we support it.
    const supportedLangs = [/*"en",*/ 'fr'];
    supportedLangs.forEach((language) => {
      this.translate.reloadLang(language);
    });

    this.router.events.subscribe(event => {
      if (event instanceof GuardsCheckStart) {
        this.isApplicationLoading = true;
        console.log('GuardStart');
      }
      if (event instanceof GuardsCheckEnd || event instanceof NavigationCancel) {
        this.isApplicationLoading = false;
        console.log('GuardEnd');
      }
    });
  }
}
